<template>
  <div class="container">
        <div class="wrap">
            <pageHeader/>
            <pageBack/>
            <!-- src="https://test.sc.cloudyiso.com/yu/0322.mp4" -->
            <video ref="video" autoplay playsinline></video>
    
    <!-- <canvas ref="canvas" width="370" height="480" style="z-index:9999"></canvas> -->
            <div class="form">
              <div class="form-div">
                <div class="form-content d-flex justify-content-between">
                  <div class="user-info">
                    <div class="font40 ">请选择性别</div>
                    <div class="sex-div d-flex ">
                      <div class="align-items-center d-flex" :class="{ on: sex == '男' }" @click="sexChange('男')">
                        <img src="../../assets/info/male.png" alt="" srcset="">
                        <span>男士</span>
                      </div>
                      <div class="align-items-center d-flex" :class="{ on: sex == '女' }" @click="sexChange('女')">
                        <img src="../../assets/info/frame.png" alt="" srcset="">
                        <span>女士</span>
                      </div>
                    </div>
                    <div class="font40 ">请输入身高</div>
                    <div class="body-div" style="margin-bottom:.76rem" @click="showKeyboard('height')" :class="{'on':inputType=='height'}">
                      <input type="text" readonly v-model="heightText" placeholder="请输入">
                      <span>cm</span>
                    </div>
                    <div class="font40 ">请输入体重</div>
                    <div class="body-div" @click="showKeyboard('weight')" :class="{'on':inputType=='weight'}">
                      <input type="text" readonly v-model="weightText" placeholder="请输入">
                      <span>kg</span>
                    </div>
                  </div>
                  <div class="keyboard" v-if="isShowKeyboard">
                    <div class="keyboard-tit d-flex justify-content-between align-items-center">
                      <span>请输入体重</span>
                      <!-- <img src="../../assets/info/Vector.png" alt="" srcset=""> -->
                    </div>
                    <div class="key-list d-flex">
                      <div v-for="(item,index) in keyboard" :key="index" @click="handleKeyPress(item)">
                        <span>{{item}}</span>
                      </div>
                      <div @click="handleKeyPress('.')">
                        <span>.</span>
                      </div>
                      <div @click="handleKeyPress(0)">
                        <span>0</span>
                      </div>
                      <div @click="handleKeyPress('-')">
                        <img src="../../assets/info/delete.png" alt="" srcset="">
                      </div>
                    </div>
                    <!-- <button>确定</button> -->
                  </div>
                </div>
                <div class="start-btn" @click="to_link()">
                  <img src="../../assets/index/btn_bg.png" alt="" srcset="">
                  <p>
                    <span>开始量体</span>
                  </p>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
// import CameraComponent from '../../components/CameraComponent.vue'
import { Toast } from 'vant';
import { addTask } from '@/api/user';
export default {
  name: 'userInfo',
  data() {
    return {
      sex:'男',
      keyboard:[1,2,3,4,5,6,7,8,9],
      stream: null, // 存储媒体流对象
      isShowKeyboard:false,
      heightText:'',
      weightText:'',
      inputType:''
    }
  },
  
  // components:{
  //   CameraComponent
  // },
  methods: {
    sexChange(i){
      this.sex = i
    },
    // 开始摄像头
    startCamera() {
      // environment
      navigator.mediaDevices.getUserMedia({ video:  { facingMode: "user" }, audio: false })
        .then((mediaStream) => {
          this.$refs.video.srcObject = mediaStream;
          this.stream = mediaStream; // 保存媒体流对象以便后续停止使用
          this.$refs.video.play(); // 确保视频播放
        })
        .catch((err) => {
          console.error("navigator.getUserMedia error:", err);
        });
    },
    // 停止摄像头
    stopCamera() {
      if (this.stream) {
        const tracks = this.stream.getTracks();
        tracks.forEach(track => track.stop()); // 停止所有轨道
        this.$refs.video.srcObject = null; // 清除视频源
        this.stream = null;
      }
    },
    showKeyboard(type){
      this.inputType = type
      this.isShowKeyboard = true
      console.log('this.inputType',this.inputType)
    },
    handleKeyPress(key) {
      let item = ''
      if(this.inputType=='height'){
          item = 'heightText'
        }else if(this.inputType=='weight'){
          item = 'weightText'
          let num = this.weightText+key
          console.log('num',num)
          if(num>100){
            Toast('体重已超过最大显示，请确认是否正确');
            return
          }
        }
      if (key === '-') {
        // 删除操作
          this[item] = this[item].slice(0, -1);
      } else {
        // 添加字符到输入框
        this[item] += key;
      }
    },
    to_link(){
      // this.$router.push('/aiFitter');
      if(!this.heightText){
        Toast('请输入身高');
        return
      }
      if(!this.weightText){
        Toast('请输入体重');
        return
      }
      let user = {
        sex: this.sex,
        height: this.heightText,
        weight: this.weightText,
      }
      addTask(user).then((res) => {
          if (res.code === 1) {
            localStorage.setItem('userInfo', JSON.stringify(user));
            localStorage.setItem('taskId', res.data);
            console.log('taskId', res.data);
            // Toast('任务id',res.data);
            this.$router.push('/aiFitter');
          }
      });
    }
  },
  // 例如这个函数就会在组件挂载完成后被调用
  mounted() {
    // 页面加载完成后自动调用摄像头
    this.startCamera();
  },
  beforeDestroy() {
    // 组件销毁前确保停止摄像头
    if (this.stream) {
      this.stopCamera();
    }
  }
}
</script>
<style src="./index.less" scoped lang="less"></style>